<template lang='pug' src='./home.pug'></template>

<script>
import Contact from 'components/custom/custom-home-contact/custom-home-contact'
import Announcement from 'components/custom/custom-announcement/custom-announcement'
import Loader from 'components/loader/loader'
import HomeHero from 'components/hero/hero'
import Social from 'components/custom/custom-home-social/custom-home-social'
import Testimonials from 'components/custom/custom-home-testimonials/custom-home-testimonials'
import Welcome from 'components/custom/custom-home-welcome/custom-home-welcome'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Contact,
    Announcement,
    HomeHero,
    Loader,
    Social,
    Testimonials,
    Welcome
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?4a397eaf